module.exports = "  <router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main